import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'XTitleLabel',
  props: {
  title: {
    type: String,
    default: ''
  },
  required: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: _normalizeClass(["x1s-item-title", {'required' : props.required}])
  }, _toDisplayString(props.title), 3))
}
}

})